export const getChartHeight = (height) => {
  switch (height) {
    case 'extra-small':
      return '128px'
    case 'small':
      return '256px'
    case 'medium':
      return '384px'
    case 'large':
      return '512px'
    default:
      return 'fit-content'
  }
}
